import {
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  inject,
} from '@angular/core';
import {
  AccionesRol,
  IActivo,
  IFilter,
  IPopulate,
  IQueryParam,
  IUsuario,
} from 'modelos/src';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { FormularioDialogService } from '../../../../auxiliares/servicios/formulario-dialog.service';
import { AuxiliaresModule } from '../../../../auxiliares/auxiliares.module';
import { DialogService } from '../../../../auxiliares/dialog/dialog.service';
import { HelperService } from '../../../../auxiliares/servicios/helper.service';
import { ActivosService } from '../../../../auxiliares/servicios/http/activos.service';
import { ParamsService } from '../../../../auxiliares/servicios/params.service';
import {
  IRegExpSearch,
  IFiltroTabla,
} from '../../../../auxiliares/tabla/filtro/filtro.component';
import {
  IColumnas,
  ICrearBoton,
} from '../../../../auxiliares/tabla/tabla.component';
import { AsignarVehiculoChoferComponent } from '../asignar-vehiculo-chofer/asignar-vehiculo-chofer.component';
import {
  CrearEditarUsuarioFuncionComponent,
  DataUsuarioFuncion,
} from '../../usuarios-por-funcion/crear-editar-usuario-funcion/crear-editar-usuario-funcion.component';
import { Lista2Service } from '../../../../auxiliares/servicios/lista2.service';
import {
  IUsuarioConPermiso,
  UsuariosService,
} from '../../../../auxiliares/servicios/http/usuarios.service';
import { PermisosService } from '../../../../auxiliares/servicios/http/permisos.service';
import { ClienteJerarquiaService } from '../../../../auxiliares/servicios/cliente-jerarquia.service';

// Fila: usuario (aplanado del permiso de función) + vehículo asignado + permiso adjunto.
interface IUsuarioTabla extends IUsuarioConPermiso {
  vehiculo?: string;
}
@Component({
  imports: [AuxiliaresModule],
  selector: 'app-listado-choferes',
  templateUrl: './listado-choferes.component.html',
  styleUrl: './listado-choferes.component.scss',
  standalone: true,
})
export class ListadoChoferesComponent implements OnInit, OnDestroy {
  private clienteJerarquia = inject(ClienteJerarquiaService);
  private lista2 = inject(Lista2Service);
  helper = inject(HelperService);
  private dialogService = inject(DialogService);
  private service = inject(UsuariosService);
  private permisosService = inject(PermisosService);
  private navigator = inject(Router);
  private route = inject(ActivatedRoute);
  private formularios = inject(FormularioDialogService);
  activosService = inject(ActivosService);
  paramsService = inject(ParamsService);

  //// Tabla nueva
  public name = 'ListadoChoferesComponent';
  public usuarios?: IUsuarioTabla[];

  public vehiculos: IActivo[] = [];
  public tipoUsuario: 'Chofer' | 'Conductor' = 'Conductor';

  public totalCount = 0;
  public columnas?: IColumnas<IUsuarioTabla>[];

  // Visor de foto (avatar de la columna Foto)
  public fotoVisible = false;
  public fotoUrl = '';
  public fotoAlt = '';

  @HostListener('click', ['$event'])
  onAvatarClick(event: MouseEvent): void {
    const fotoEl = (event.target as HTMLElement).closest(
      '[data-foto-url]',
    ) as HTMLElement | null;
    if (!fotoEl) return;
    this.fotoUrl = fotoEl.getAttribute('data-foto-url')!;
    this.fotoAlt = fotoEl.getAttribute('data-foto-alt') || '';
    this.fotoVisible = true;
    event.stopPropagation();
  }

  //Subs
  public usuarios$?: Subscription;
  public vehiculos$?: Subscription;
  //

  public botonCrear: ICrearBoton;
  // La búsqueda corre sobre la entidad Permiso: nombreUsuario es el username
  // (identificacionInterna vive en el doc Usuario, relación virtual, no filtrable acá).
  public search: IRegExpSearch = {
    fields: ['nombreUsuario'],
  };
  // FILTROS
  // Mismo selector de cliente que el listado de vehículos (árbol de clientes).
  // El ngselect con elementos:[] no se poblaba nunca, por eso no filtraba.
  public cliente: IFiltroTabla = {
    filter: {
      field: 'idCliente',
    },
    label: 'Cliente',
    tipo: 'cliente-selector',
  };
  // Cliente en cuya jerarquía cuelga la entidad: el cliente elegido y toda su
  // descendencia.
  public ancestro: IFiltroTabla = {
    filter: {
      field: 'idsAncestros',
      incluirPropio: true,
    },
    label: 'En la jerarquía de',
    tipo: 'cliente-selector',
  };
  public filtros: IFiltroTabla[] = [];

  public populate: IPopulate = {
    path: 'cliente',
    select: 'nombre',
  };
  public query: IQueryParam = {
    populate: JSON.stringify(this.populate),
    sort: 'nombreUsuario',
    page: 0,
    limit: +this.helper.getPageSize(this.name),
    includeChildren: false,
    childrenLevel: 0,
  };

  public filterVehiculos: IFilter<IUsuario> = {};
  public queryVehiculos: IQueryParam = {
    filter: JSON.stringify(this.filterVehiculos),
    page: 0,
    limit: +this.helper.getPageSize(this.name),
    includeChildren: false,
    childrenLevel: 0,
  };
  // Listars
  public async listar(): Promise<void> {
    if (this.tipoUsuario === 'Chofer') {
      this.usuarios$?.unsubscribe();
      this.usuarios$ = this.lista2.chofers(this.query, 30).subscribe((data) => {
        this.totalCount = data.totalCount;
        this.usuarios = data.datos as IUsuarioTabla[];
        this.vehiculosUsuarioTabla();
      });
    } else if (this.tipoUsuario === 'Conductor') {
      this.usuarios$?.unsubscribe();
      this.usuarios$ = this.lista2
        .conductors(this.query, 30)
        .subscribe((data) => {
          this.totalCount = data.totalCount;
          this.usuarios = data.datos as IUsuarioTabla[];
          this.vehiculosUsuarioTabla();
        });
    }
  }

  public async listarVehiculos(): Promise<void> {
    this.vehiculos$?.unsubscribe();
    if (this.tipoUsuario === 'Chofer') {
      this.vehiculos$ = this.lista2
        .colectivos(this.queryVehiculos, 30)
        .subscribe((data) => {
          this.vehiculos = data.datos;
          this.vehiculosUsuarioTabla();
        });
    } else if (this.tipoUsuario === 'Conductor') {
      this.vehiculos$ = this.lista2
        .vehiculos(this.queryVehiculos, 30)
        .subscribe((data) => {
          this.vehiculos = data.datos;
          this.vehiculosUsuarioTabla();
        });
    }
  }

  private vehiculosUsuarioTabla() {
    if (!this.usuarios) return;
    const map = new Map(this.vehiculos.map((v) => [v?.vehiculo?.idChofer, v]));
    this.usuarios.forEach((u) => {
      const match = map.get(u._id);
      if (match) {
        u.vehiculo = match.identificacion;
      }
    });
  }
  // Acciones
  public async crear() {
    const data: DataUsuarioFuncion = {
      editando: false,
      funcion: this.tipoUsuario === 'Chofer' ? 'Chofer' : 'Conductor',
    };
    const res = this.formularios.abrir(CrearEditarUsuarioFuncionComponent, {
      tamano: 'grande',
      data,
    });
    res.afterClosed().subscribe(async (d) => {
      if (d) {
        await this.listar();
      }
    });
  }

  public async editar(usuario: IUsuarioTabla) {
    const data: DataUsuarioFuncion = {
      editando: true,
      permiso: usuario.permiso,
      funcion: this.tipoUsuario === 'Chofer' ? 'Chofer' : 'Conductor',
    };
    const res = this.formularios.abrir(CrearEditarUsuarioFuncionComponent, {
      tamano: 'grande',
      data,
    });
    res.afterClosed().subscribe(async (d) => {
      if (d) {
        await this.listar();
      }
    });
  }
  // ASIGNAR VEHICULO AL CHOFER
  public asignarVehiculo(user: IUsuario) {
    const data = {
      usuario: user,
      tipo:
        this.tipoUsuario === 'Chofer'
          ? 'Colectivos'
          : this.tipoUsuario === 'Conductor'
            ? 'Vehiculos'
            : '',
    };
    const res = this.formularios.abrir(AsignarVehiculoChoferComponent, {
      tamano: 'chico',
      data,
    });

    res.afterClosed().subscribe(async (d) => {
      if (d) {
        await this.listar();
      }
    });
  }

  public ventanaDocumentos(data: IUsuario) {
    this.navigator.navigate([
      '/',
      'main',
      'administracion',
      'documentos',
      data._id,
      'Usuario',
      this.tipoUsuario === 'Chofer'
        ? 'Colectivo'
        : this.tipoUsuario === 'Conductor'
          ? 'Vehiculo'
          : '',
    ]);
  }

  public async verificarChofer(usuario: IUsuario): Promise<void> {
    const veh = this.vehiculos.find((v) => v.vehiculo.idChofer == usuario._id);
    if (veh && veh._id) {
      await this.activosService.update(veh._id, {
        vehiculo: { idChofer: null },
      });
    }
  }

  public async eliminar(usuario: IUsuarioTabla) {
    const entidad = this.tipoUsuario === 'Chofer' ? 'chofer' : 'conductor';
    const idPermiso = usuario.permiso?._id;
    if (!idPermiso) {
      this.helper.notifError('No se encontró el permiso del usuario');
      return;
    }
    const res = await this.dialogService.confirm(
      `Eliminar ${this.tipoUsuario}`,
      `¿Querés eliminar el permiso de ${entidad} de ${usuario.usuario}?`,
    );
    if (!res) return;
    try {
      await this.verificarChofer(usuario);
      await this.permisosService.delete(idPermiso);
      this.helper.notifSuccess(`${this.tipoUsuario} eliminado`);
      await this.listar();
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
  }

  // Tabla

  private setColumnas() {
    const accionEditar: AccionesRol =
      this.tipoUsuario === 'Chofer'
        ? 'Colectivos - Editar choferes'
        : 'Vehículos - Editar conductor';
    const accionAsignar: AccionesRol =
      this.tipoUsuario === 'Chofer'
        ? 'Colectivos - Editar' // TODO: Reemplazar por asignar chofer
        : 'Vehículos - Asignar conductor';
    const accionDocumentos: AccionesRol =
      this.tipoUsuario === 'Chofer'
        ? 'Colectivos - Editar' // TODO: Reemplazar por algo de documentos chofer
        : 'Vehículos - Editar documentos conductor';
    const accionEliminar: AccionesRol =
      this.tipoUsuario === 'Chofer'
        ? 'Colectivos - Eliminar choferes'
        : 'Vehículos - Eliminar conductor';

    this.columnas = [
      {
        header: { label: 'Foto' },
        row: {
          html: (dato) =>
            HelperService.avatarHtml(
              dato.datosPersonales?.foto,
              dato.datosPersonales?.nombre || dato.usuario,
            ),
        },
      },
      {
        header: {
          label: 'Usuario',
          sortable: true,
        },
        row: {
          field: 'usuario',
          noData: 'Sin usuario',
        },
      },
      {
        header: {
          label: 'Nombre',
        },
        row: {
          parse(dato) {
            return dato.datosPersonales?.nombre;
          },
          noData: 'Sin nombre',
        },
      },
      {
        header: {
          label: 'Fecha de creación',
          sort: 'fechaCreacion',
          sortable: true,
        },
        row: {
          fecha: (dato) => dato.fechaCreacion,
          noData: 'Sin fecha',
        },
      },
      {
        header: {
          label: 'Vehículo',
          sortable: true,
        },
        row: {
          field: 'vehiculo',
          noData: 'Sin vehículo',
        },
      },
    ];
    // Cliente
    if (HelperService.getTipoCliente() !== 'Final') {
      {
        this.columnas.push({
          header: {
            label: 'Cliente',
          },
          row: {
            html: (dato) => this.clienteJerarquia.htmlNombre(dato.cliente),
            tooltip: (dato) =>
              this.clienteJerarquia.tooltipJerarquia(dato.cliente),
            noData: 'Sin cliente',
          },
        });
      }
    }

    this.columnas.push({
      header: {
        label: 'Acciones',
      },
      row: {
        acciones: [
          {
            tipo: 'material',
            color: 'primary',
            icon: 'edit',
            tooltip: 'Editar',
            click: (dato) => this.editar(dato),
            disabled: () => !this.helper.tienePermiso(accionEditar),
          },
          {
            tipo: 'material',
            color: 'primary',
            // Colectivo para choferes, vehículo para conductores
            icon:
              this.tipoUsuario === 'Chofer' ? 'directions_bus' : 'directions_car',
            tooltip: 'Asignar vehículo',
            click: (dato) => this.asignarVehiculo(dato),
            disabled: () => !this.helper.tienePermiso(accionAsignar),
          },
          {
            tipo: 'material',
            color: 'primary',
            icon: 'description',
            tooltip: 'Documentos',
            click: (dato) => this.ventanaDocumentos(dato),
            disabled: () => !this.helper.tienePermiso(accionDocumentos),
          },
          {
            tipo: 'material',
            color: 'warn',
            icon: 'delete',
            tooltip: 'Eliminar',
            click: (dato) => this.eliminar(dato),
            disabled: () => !this.helper.tienePermiso(accionEliminar),
          },
        ],
      },
    });
  }

  // Hooks

  async ngOnInit() {
    const currentUrl = this.navigator.url;
    this.tipoUsuario = currentUrl.endsWith('/choferes')
      ? 'Chofer'
      : 'Conductor';

    if (HelperService.getTipoCliente() !== 'Final') {
      this.cliente.filtroSelector = [
        this.tipoUsuario === 'Chofer' ? 'moduloColectivos' : 'moduloVehiculos',
      ];
      this.filtros.push(this.cliente);
      this.filtros.push(this.ancestro);
    }
    const accionCrear: AccionesRol =
      this.tipoUsuario === 'Chofer'
        ? 'Colectivos - Crear choferes'
        : 'Vehículos - Crear conductor';

    this.botonCrear = {
      mostrar: this.helper.tienePermiso(accionCrear),
      tooltip: `Crear ${this.tipoUsuario.toLowerCase()}`,
      color: 'primary',
      tipo: 'material',
      icon: 'add',
      accion: () => this.crear(),
    };
    await this.listar();
    await this.listarVehiculos();

    this.setColumnas();
  }

  ngOnDestroy() {
    this.usuarios$?.unsubscribe();
    this.vehiculos$?.unsubscribe();
  }
}
